import useUrlParamLinks from "../../modules/Data/useUrlParamLinks";

export interface UseUiMQRCodeOverlayProps {
  arUrl: string;
}

const useUiMQRCodeOverlay = (): UseUiMQRCodeOverlayProps => {
  const { createIntentUrlLink } = useUrlParamLinks();

  return {
    arUrl: createIntentUrlLink(),
  };
};

export default useUiMQRCodeOverlay;
